

/**adiona `|` para separar o nome da profundidade */
export function replaceCalcario(nome_calcario: string): string {
    switch (nome_calcario) {
        case 'Calcário 00-20':
            return 'Calcário | 00-20'

        case 'Calcário | 00-20':
            return 'Calcário 00-20'

        case 'Calcário 00-30':
            return 'Calcário | 00-30'

        case 'Calcário 00-40':
            return 'Calcário | 00-40'

        default:
            return nome_calcario
    }
}

/**verifica se o elemento se chama `Calcário 20-40` em diferentes variações */
export function removerCalcario2040(dataElemento: any): boolean {
    if (dataElemento.cod_elemento !== 30) {
        return false;
    }
    const descricoes = new Set([
        'Calcário | 20-40',
        'Calcario | 20-40',
        'calcário | 20-40',
        'calcario | 20-40',
        'Calcário - 20-40',
        'Calcario - 20-40',
        'calcário - 20-40',
        'calcario - 20-40',
        'Calcário - 20 - 40',
        'Calcario - 20 - 40',
        'calcário - 20 - 40',
        'calcario - 20 - 40',
        'Calcário 20-40',
        'Calcario 20-40',
        'calcário 20-40',
        'calcario 20-40',
        'Calcário | 20 a 40',
        'Calcario | 20 a 40',
        'calcário | 20 a 40',
        'calcario | 20 a 40',
        'Calcário - 20 a 40',
        'Calcario - 20 a 40',
        'calcário - 20 a 40',
        'calcario - 20 a 40',
        'Calcário 20 a 40',
        'Calcario 20 a 40',
        'calcário 20 a 40',
        'calcario 20 a 40',
        'Calcário 20 á 40',
        'Calcario 20 á 40',
        'calcário 20 á 40',
        'calcario 20 á 40',
        'Calcário 20 à 40',
        'Calcario 20 à 40',
        'calcário 20 à 40',
        'calcario 20 à 40',
    ]);

    return descricoes.has(dataElemento?.elemento_descricao);
}

/**A pedido do Ronaldo em 18/06/2025 08:58 (whats Clay) 
 * 
 * Quando não tiver análise 20 a 40 cm não podemos gerar recomendação de calcário 00 a 30 cm, somente 00 a 20 cm;
 * 
 * Precisa ver com o back se essa func é necessária, pois dependendo, o back já nem esteja retornando 20-40
 * 
*/
export function removerCalcario0030Condicialmente(lista_krigagens: any[], nome_elemento: string, lista_elementos: any) {

    if (nome_elemento!=='Calcário | 00-30') return false;
    
    /**verifica se existe profundidade 20-40 apenas na listagem de calcário */
    let apenas_calcario_20_40_calcario = lista_krigagens?.filter(item=> item.descriptionElemento === 'Calcário | 20-40');
    
    /**verifica se existe profundidade 20-40 em qualquer um dos elementos */
    // let apenas_calcario_20_40_geral = lista_elementos?.filter(item=> item.profundidade === "20-40");

    return nome_elemento ==='Calcário | 00-30' && apenas_calcario_20_40_calcario?.length === 0;
}